import client from '../httpClient';

const defaultOption = {
  isShowLoading: false,
  isShowMessage: false,
};

// 【customer018】顧客カード情報取得
/**
 * @param {string} customerId
 */
const customerGetCardsApi = async (customerId) => {
  const result = await client.get(`/customers/card/${customerId}`, { ...defaultOption });
  return result;
};

export default customerGetCardsApi;
